



export const components_data = {

    groups: [
        {
            key: "text_images",
            label: "Text & Images",
            description: ""
        },
        {
            key: "product_lists_features",
            label: "Product Lists & Features",
            description: <div style={{ "lineHeight": "16px" }}>Create static (My Lists) or dynamic (Browse Filter Preset) lists on <strong>Biz</strong> first, then select them for use within the following components</div>
        },
        {
            key: "events",
            label: "Events",
            description: <div style={{ "lineHeight": "16px" }}>Event listings are created and managed <a target="_blank" href="https://biz.bookmanager.com/content/events">here</a>.</div>
        },
        {
            key: "buttons",
            label: "Buttons",
            description: ""
        },
        {
            key: "popups_notices",
            label: "Popups & Notices",
            description: <div style={{ "lineHeight": "16px" }}>Drag these components anywhere on the page, as their exact placement does not matter. <br /><div className="shim" />Use the top Preview button to see them as they will actually render.</div>
        },
        {
            key: "widgets",
            label: "Widgets",
            description: ""
        },
        {
            key: "third_party_plugins",
            label: "Third Party Plugins",
            description: <div style={{ "lineHeight": "16px" }}>Are we missing a third-party function or service? Please contact Bookmanager support so we can potentially add it.</div>
        },
        {
            key: "custom_html_css",
            label: "Custom HTML & CSS",
            description: <div style={{ "lineHeight": "16px" }}>Warning! Custom HTML and CSS can create unintended consequences and has the potential to break your site. <div className="shim" /> Bookmanager support staff are unable to troubleshoot or assist with your code, or assist with broken website functionality as a result of using custom code. <div className="shim" />Use this option at your own risk, or better yet, contact Bookmanager support to see if there is an alternate approach.</div>
        },
    ],

    components: [

        // Text Images
        {
            key: "blank_space",
            label: "Blank Space",
            icon: "Blank_Space_Icon.svg",
            group: "text_images",
            container: false,
            data: {
                height: 30,
                background_colour: 0,
            }
        },
        {
            key: "headline_paragraph",
            label: "Headline & Paragraph",
            icon: "Headline_and_Paragraph_Icon.svg",
            group: "text_images",
            container: true,
            data: {
                name: "Headline & Paragraph",
                gap: 0,
                width: 60,
                align: "center",
                text_align: "center",
                padding_x: 20,
                padding_y: 20,
                heading: "Headline & Paragraph",
                heading_preset: 0,
                paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit. Sed at tempus ante. Interdum et malesuada fames primis in faucibus.",
                paragraph_preset: 0,
            }
        },
        {
            key: "text_columns",
            label: "Text columns",
            icon: "Text_Columns_Icon.svg",
            group: "text_images",
            container: true,
            data: {
                name: "Text Columns",
                width: 1248,
                contained: false,
                padding_y: 10,
                padding_x: 10,
                background_colour: 0,
                headline_preset: 0,
                paragraph_preset: 0,
                align: "center",
                column_text_align: "left",
                link_id: 0,
                gap: 10,
                spacer: 0,
                spacer_colour: 0,
                border: 0,
                border_colour: 0,
                columns: 3,
                allow_segment_breaks: false,
                mobile_columns: 1,
                mobile_padding_y: 10,
                mobile_padding_x: 10,
                allow_mobile_overrides: false,
                segments: [
                    { headline: "Title", label: "Unnamed", paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec condimentum facilisis maximus. Aenean quis purus id erat pulvinar commodo. Nam accumsan id nibh vel dignissim. Donec ac velit leo. Curabitur id mollis libero. Morbi tincidunt eros vel arcu sodales, consectetur faucibus risus varius. In non mattis erat, consequat ultricies nulla. Nullam vitae diam nisi. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis feugiat nec erat finibus dictum. Donec eget eros faucibus, dapibus nisl vitae, aliquet purus. Nunc at ullamcorper enim." },
                    { headline: "Title", label: "Unnamed", paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec condimentum facilisis maximus. Aenean quis purus id erat pulvinar commodo. Nam accumsan id nibh vel dignissim. Donec ac velit leo. Curabitur id mollis libero. Morbi tincidunt eros vel arcu sodales, consectetur faucibus risus varius. In non mattis erat, consequat ultricies nulla. Nullam vitae diam nisi. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis feugiat nec erat finibus dictum. Donec eget eros faucibus, dapibus nisl vitae, aliquet purus. Nunc at ullamcorper enim." },
                    { headline: "Title", label: "Unnamed", paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec condimentum facilisis maximus. Aenean quis purus id erat pulvinar commodo. Nam accumsan id nibh vel dignissim. Donec ac velit leo. Curabitur id mollis libero. Morbi tincidunt eros vel arcu sodales, consectetur faucibus risus varius. In non mattis erat, consequat ultricies nulla. Nullam vitae diam nisi. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis feugiat nec erat finibus dictum. Donec eget eros faucibus, dapibus nisl vitae, aliquet purus. Nunc at ullamcorper enim." },
                ],
                image_radius: 0,
            }
        },
        {
            key: "image_gif",
            label: "Image / GIF",
            icon: "Image_GIF_Icon.svg",
            group: "text_images",
            container: true,
            data: {
                name: "Image / GIF",
                background_colour: 0,
                image: "https://bookmanager.com/i/sample_content/placeholder.jpg",
                align: "center",
                link: "",
                new_tab: true,
                padding_x: 10,
                padding_y: 10,
                width: 1248,
                has_width: false,
                image_radius: 0
            }
        },
        {
            key: "table_grid",
            label: "Table Grid",
            icon: "Table_Grid.svg",
            group: "text_images",
            container: true,
            data: {
                name: "Table Grid",
                header_bg_colour: 0,
                background_colour: 0,
                row_preset: 0,
                row_colour: 0,
                alternating_colour: 0,
                fixed_width: false,
                border_thickness: 0,
                border_colour: 0,
                align: "left",
                height: 1000,
                width: 1248,
                has_width: false,
                has_height: false,
                css_id: "",
                padding_x: 10,
                padding_y: 10,
                alternating: false,
                columns: [
                    { header: "Column 1", padding_x: 0, padding_y: 0, text_align: "left", header_preset: 0, min_width: 200 },
                    { header: "Column 2", padding_x: 0, padding_y: 0, text_align: "left", header_preset: 0, min_width: 200 },
                    { header: "Column 3", padding_x: 0, padding_y: 0, text_align: "left", header_preset: 0, min_width: 200 },
                ],
                rows: [
                    { data: "Row 1 Column 1", check: false }, { data: "Row 1 Column 2", check: false }, { data: "Row 1 Column 3", check: false },
                ],

                allow_mobile_overrides: false,
                mobile_width: 100,
                mobile_height: 200,
            }
        },
        {
            key: "text_over_image",
            label: "Text Over Image",
            icon: "Text_Over_Image_Icon.svg",
            group: "text_images",
            container: true,
            data: {
                name: "Text Over Image",
                background_image: "https://bookmanager.com/i/sample_content/bg_placeholder.jpg",
                background_margin_top: 30,
                background_margin_right: 30,
                background_margin_bottom: 30,
                background_margin_left: 30,
                background_colour: 0,
                background_size: "cover",
                bg_horizontal_align: "center",
                bg_vertical_align: "center",
                text_container: true,
                text_background_colour: 0,
                text_background_radius: 0,
                width: 50,
                align: "center",
                textAlign: "center",
                padding_x: 10,
                padding_y: 10,
                bg_padding_x: 0,
                bg_padding_y: 0,
                heading: "Text Over Image",
                heading_preset: 0,
                paragraph: "Lorem ipsum dolor sit amet, consectetur et malesuada fames ac ante ipsum adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit. Sed at tempus ante. Interdum et malesuada fames ac ante ipsum primis in faucibus.",
                paragraph_preset: 0,
                button_url: "",
                button_label: "",
                button_type: 0,
                button_tab: true,
                button_block: false,
                background_image_radius: 0
            }
        },

        {
            key: "text_over_parallax",
            label: "Text Over Parallax",
            icon: "Text_Over_Image_Icon.svg",
            group: "text_images",
            container: false,
            data: {
                name: "Text Over Parallax",
                background_image: "https://bookmanager.com/i/sample_content/default_parallax.jpg",
                background_colour: 0,
                text_container: true,
                text_background_colour: 0,
                text_background_radius: 0,
                height: 600,
                width: 55,
                align: "center",
                text_align: "center",
                bg_padding_x: 0,
                bg_padding_y: 0,
                padding_x: 10,
                padding_y: 10,
                margin_x: 0,
                margin_y: 0,
                vertical_position: "center",
                heading: "Heading...",
                heading_preset: 0,
                paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit. Sed at tempus ante. Interdum et malesuada fames ac ante ipsum primis in faucibus.",
                paragraph_preset: 0,
                button_url: "",
                button_label: "",
                button_type: 0,
                button_tab: true,
                button_block: false,
            }
        },


        // {
        //     key: "banner",
        //     label: "Banner",
        //     icon: "Text_Over_Image_Icon.svg",
        //     group: "text_images",
        //     container: true,
        //     data: {
        //         name: "Banner",
        //         background_image: "https://bookmanager.com/i/sample_content/bg_placeholder.jpg",
        //         background_colour: 0,
        //         padding_x: 0,
        //         padding_y: 0,
        //         slice_top: 0,
        //         slice_left: 0,
        //         slice_right: 0, 
        //         slice_bottom: 0,
        //     }
        // },

        {
            key: "text_over_video",
            label: "Text Over Video",
            icon: "Text_Over_Video_Icon.png",
            group: "text_images",
            container: true,
            data: {
                name: "Text Over Video",
                background_video: "https://bookmanager.com/i/sample_content/placeholder.mp4",
                background_colour: 0,
                text_container: true,
                text_background_colour: 0,
                text_background_radius: 0,
                width: 60,
                align: "center",
                textAlign: "center",
                padding_x: 10,
                padding_y: 10,
                bg_padding_x: 10,
                bg_padding_y: 30,
                heading: "Text Over Video",
                heading_preset: 0,
                paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit. Sed at tempus ante. Interdum et malesuada fames ac ante ipsum primis in faucibus.",
                paragraph_preset: 0,
                button_url: "",
                button_label: "",
                button_type: 0,
                button_tab: true,
                button_block: false,
            }
        },
        {
            key: "side_by_side_text_image",
            label: "Side by Side: Text & Image",
            icon: "Side_by_Side_Text_Image_Icon.svg",
            group: "text_images",
            container: true,
            data: {
                name: "Side by Side: Text & Image",
                background_image: "https://bookmanager.com/i/sample_content/placeholder.jpg",
                flip: false,
                background_size: "cover",
                bg_horizontal_align: "center",
                bg_vertical_align: "center",
                text_container: true,
                container_width: 1248,
                text_background_colour: 0,
                text_padding_x: 0,
                text_padding_y: 0,
                background_colour: 0,
                width: 40,
                justify: "center",
                image_width: 50,
                image_height: 400,
                align: "center",
                textAlign: "center",
                padding_x: 0,
                padding_y: 0,
                heading: "Text & Image",
                heading_preset: 0,
                paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit. Sed at tempus ante. Interdum et malesuada fames ac ante ipsum primis in faucibus.",
                paragraph_preset: 0,
                button_url: "",
                button_label: "",
                button_type: 0,
                button_tab: true,
                button_block: false,
                background_image_radius: 0
            }
        },
        {
            key: "side_by_side_text_button",
            label: "Side by Side: Text & Button",
            icon: "Side_by_Side_Text_Button_Icon.svg",
            group: "text_images",
            container: true,
            data: {
                name: "Side by Side: Text & Button",
                flip: false,
                text_container: true,
                container_width: 1248,
                text_background_colour: 0,
                text_padding_x: 0,
                text_padding_y: 0,
                text_width: 50,
                text_interior_align: "center",
                background_colour: 0,
                width: 40,
                align: "center",
                textAlign: "center",
                padding_x: 10,
                padding_y: 10,
                heading: "Text & Button",
                heading_preset: 0,
                paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit. Sed at tempus ante. Interdum et malesuada fames ac ante ipsum primis in faucibus.",
                paragraph_preset: 0,
                buttons: [
                    { label: "Button", link: "", tab: true },
                    { label: "Button", link: "", tab: true },
                    { label: "Button", link: "", tab: true },
                ],
                button_type: 0,
                button_block: false,
            }
        },
        {
            key: "image_grid",
            label: "Image Grid",
            icon: "Image_Grid_Icon.svg",
            group: "text_images",
            container: true,
            data: {
                name: "Image Grid",
                width: 400,
                height: 300,
                padding_y: 10,
                padding_x: 10,
                horizontal_align: "center",
                vertical_align: "center",
                size: "cover",
                gap_y: 10,
                gap_x: 10,
                justify: "space-evenly",
                background_colour: 0,
                images: [
                    { path: "https://bookmanager.com/i/sample_content/placeholder.jpg", alt: "", link: "", tab: true },
                    { path: "https://bookmanager.com/i/sample_content/placeholder.jpg", alt: "", link: "", tab: true },
                    { path: "https://bookmanager.com/i/sample_content/placeholder.jpg", alt: "", link: "", tab: true },
                    { path: "https://bookmanager.com/i/sample_content/placeholder.jpg", alt: "", link: "", tab: true },
                    { path: "https://bookmanager.com/i/sample_content/placeholder.jpg", alt: "", link: "", tab: true },
                    { path: "https://bookmanager.com/i/sample_content/placeholder.jpg", alt: "", link: "", tab: true }
                ],
                image_radius: 0,
            }
        },

        {
            key: "accordion",
            label: "Accordion",
            icon: "accordion.svg",
            group: "text_images",
            container: true,
            data: {
                label: "FAQ",
                width: 1248,
                has_width: false,
                label_preset: 0,
                header_preset: 0,
                is_accordion: false,
                is_ghost: false,
                paragraph_background: 0,
                align: "center",
                arrow_colour: 0,
                arrow_size: 15,
                paragraph_preset: 0,
                background_colour: 0,
                padding_x: 10,
                padding_y: 10,
                faq: [
                    { headline: "Headline", label: "Unnamed", paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit." },
                    { headline: "Headline", label: "Unnamed", paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit." },
                    { headline: "Headline", label: "Unnamed", paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit." },
                ],

                allow_mobile_overrides: false,
                mobile_arrow_size: 15,
            }
        },

        {
            key: "image_carousel",
            label: "Image Carousel",
            icon: "Image_Carousel_Icon.svg",
            group: "text_images",
            container: false,
            data: {
                name: "Image Carousel",
                animation: "scroll",
                height: 500,
                width: 0,
                padding_y: 0,
                padding_x: 0,
                background_colour: 0,
                button_type: 0,
                bg_horizontal_align: "center",
                bg_vertical_align: "center",
                background_size: "cover",
                align: "center",
                images: [
                    { path: "https://bookmanager.com/i/sample_content/bg_placeholder.jpg", headline: "", paragraph: "", button: "", alt: "", link: "", tab: true, header: "", paragraph: "", button_label: "" },
                    { path: "https://bookmanager.com/i/sample_content/bg_placeholder.jpg", headline: "", paragraph: "", button: "", alt: "", link: "", tab: true, header: "", paragraph: "", button_label: "" },
                    { path: "https://bookmanager.com/i/sample_content/bg_placeholder.jpg", headline: "", paragraph: "", button: "", alt: "", link: "", tab: true, header: "", paragraph: "", button_label: "" }
                ],
                auto: false,
                timeout: 5,
                image_radius: 0,
            }
        },


        {
            key: "youtube",
            label: "Video",
            icon: "Video_Icon.svg",
            group: "text_images",
            container: true,
            data: {
                name: "Video",
                url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
                padding_x: 0,
                padding_y: 0,
                background_colour: 0,
                width: 600,
                aspect_ratio: "16/9",
                align: "center",
                full_width: false,
            }
        },

        // Product Lists Features
        {
            key: "product_slider",
            label: "Product Slider",
            icon: "Product_Slider_Icon.svg",
            group: "product_lists_features",
            container: true,
            data: {
                name: "Product Slider",
                display_mode: "scroller",
                image_size: 120,
                constrain_container: false,
                max_width: 300,
                padding_y: 10,
                padding_x: 10,
                gap: 10,
                list_id: "",
                actual_list_id: 0,
                limit: 16,
                show_title: false,
                title_preset: 0,
                show_author: false,
                author_preset: 0,
                background_colour: 0,
                button_type: 0,
            }
        },

        // {
        //     key: "development",
        //     label: "Product Scroller",
        //     icon: "Product_Slider_Icon.svg",
        //     group: "product_lists_features",
        //     container: true,
        //     data: {
        //         name: "Product Scroller",
        //         image_size: 120,
        //         padding_y: 10,
        //         padding_x: 10,
        //         gap: 10,
        //         list_id: "",
        //         actual_list_id: 0,
        //         limit: 16,
        //         show_title: false,
        //         title_preset: 0,
        //         show_author: false,
        //         author_preset: 0,
        //         background_colour: 0,
        //         button_type: 0,
        //     }
        // },

        {
            key: "product_grid",
            label: "Product Grid",
            icon: "Product_Grid_Icon.svg",
            group: "product_lists_features",
            container: true,
            data: {
                name: "Product Grid",
                image_size: 120,
                padding_y: 10,
                padding_x: 10,
                gap_y: 10,
                gap_x: 10,
                list_id: "",
                actual_list_id: 0,
                limit: 18,
                show_title: false,
                title_preset: 0,
                show_author: false,
                author_preset: 0,
                background_colour: 0,
            }
        },

        {
            key: "single_title_feature",
            label: "Single Title Feature",
            icon: "Side_by_Side_Text_Image_Icon.svg",
            group: "product_lists_features",
            container: true,
            injected_data: {},
            data: {
                name: "Single Title Feature",
                isbn: "",
                padding_x: 10,
                padding_y: 10,
                flip: true,
                background_colour: 0,
                image_width: 20,
                text_width: 100,
                text_padding_x: 15,
                text_padding_y: 0,
                text_align: "left",
                title_preset: 0,
                author_preset: 0,
                bio_preset: 0,
                description_preset: 0,
                title_text: "Title...",
                author_text: "Author...",
                bio_text: "Bio...",
                description_text: "Description...",
                use_title: true,
                use_author: true,
                use_bio: true,
                use_description: true,
                constrain_container: false,
                container_width: 1248
            }
        },


        //Events
        {
            key: "events_calendar",
            label: "Events Calendar",
            icon: "Event_Calendar_Icon.svg",
            group: "events",
            container: true,
            data: {
                name: "Events Calendar",
                width: 500,
                full_width: false,
                align: "center",
                calendar_colour: 0,
                background_colour: 0,
                link_style: 0,
                highlight_colour: 0,
                active_colour: 0,
                text_colour: 0,
                padding_x: 0,
                padding_y: 0,
            }
        },
        {
            key: "events_calendar_upcoming",
            label: "Events Calendar + Upcoming",
            icon: "Event_Calendar_and_Upcoming_Icon.svg",
            group: "events",
            container: true,
            data: {
                name: "Events Calendar + Upcoming",
                width: 500,
                calendar_colour: 0,
                background_colour: 0,
                highlight_colour: 0,
                active_colour: 0,
                text_colour: 0,
                date_colour: 0,
                padding_x: 0,
                padding_y: 0,
                font: 0,
                title_preset: 0,
                description_preset: 0,
                date_preset: 0,
                limit: 2,
                button_type: 0,
                button_label: "View Events",
                button_align: "center",
                calendar_gap: 0,
            }
        },
        {
            key: "single_event_feature",
            label: "Single Event Feature",
            icon: "Event_Single_Feature_Icon.svg",
            group: "events",
            container: true,
            data: {
                name: "Single Event Feature",
                width: 300,
                event: 0,
                background_colour: 0,
                padding_x: 20,
                padding_y: 20,
                title_preset: 0,
                description_preset: 0,
                date_preset: 0,
                button_type: 0,
                button_label: "Buy Books",
                button_align: "center",
                button_block: false
            }
        },

        {
            key: "events_grid",
            label: "Events Grid",
            icon: "Product_Grid_Icon.svg",
            group: "events",
            container: false,
            data: {
                name: "Events Grid",
                width: 300,
                height: 300,
                padding_y: 0,
                padding_x: 0,
                horizontal_align: "center",
                vertical_align: "center",
                size: "cover",
                gap_y: 10,
                gap_x: 10,
                justify: "center",
                background_colour: 0,
                image_radius: 0,
                spacing: 10,
                categories: [],
                limit: 8,
                title_preset: 0,
                date_preset: 0,
                link_style: 0,
                text_align: "center",

                allow_mobile_overrides: false,
                mobile_height: 300,
                mobile_padding_y: 0,
                mobile_padding_x: 0
            }
        },

        // Buttons
        {
            key: "custom_button",
            label: "Button",
            icon: "",
            group: "buttons",
            container: true,
            data: {
                name: "Button",
                label: "Button",
                link: "",
                type: 0,
                tab: true,
                align: "center",
                padding_x: 0,
                padding_y: 0,
                button_block: false,
            }
        },

        {
            key: "scroll_to_top",
            label: "Scroll to Top",
            icon: "",
            group: "buttons",
            container: true,
            data: {
                name: "Scroll to Top",
                label: "Scroll to Top",
                align: "right",
                type: 0,
                arrow: false,
                allow_mobile_overrides: false,
                mobile_arrow: false,
                mobile_hide: false,
            }
        },

        {
            key: "button_grid",
            label: "Button Grid",
            icon: "Image_Grid_Icon.svg",
            group: "buttons",
            container: true,
            data: {
                name: "Button Grid",
                padding_y: 10,
                padding_x: 10,
                width: 1248,
                constrain: false,
                align: "0 auto",
                gap_y: 10,
                gap_x: 10,
                justify: "center",
                background_colour: 0,
                preset: 0,
                buttons: [
                    { label: "Button", link: "", tab: true },
                    { label: "Button", link: "", tab: true },
                    { label: "Button", link: "", tab: true },
                ],
            }
        },


        // Popups Notices
        {
            key: "above_searchbar_notice",
            label: "Above Searchbar Notice",
            icon: "Popup_Above_Searchbar_Icon.svg",
            group: "popups_notices",
            container: true,
            data: {
                message: "Above Searchbar Notice",
                font: 0,
                align: "center",
                padding_x: 5,
                padding_y: 5,
                colour: 0,
                background_colour: 0,
                link: "",
                tab: false,
            }
        },
        {
            key: "popup_notice",
            label: "Popup Notice",
            icon: "Popup_Notice_Icon.svg",
            group: "popups_notices",
            container: true,
            data: {
                name: "Popup Notice",
                background_colour: 0,
                background_radius: 0,
                width: 250,
                gap: 10,
                text_align: "center",
                padding_x: 20,
                padding_y: 20,
                heading: "Popup Notice",
                heading_preset: 0,
                paragraph: "",
                paragraph_preset: 0,
                link_button: false,
                link_button_label: "",
                link_button_url: "",
                link_button_type: 0,
                button_label: "",
                button_type: 0,
                button_block: false,
            }
        },


        {
            key: "event_list",
            label: "Events List",
            icon: "",
            group: "events",
            container: true,
            data: {
                name: "Events List",
                width: 200,
                background_colour: 0,
                padding_x: 20,
                padding_y: 20,
                title_preset: 0,
                description_preset: 0,
                date_preset: 0,
                button_type: 0,
                button_label: "Buy Books",
                button_align: "left",
                link_id: 0,
            }
        },



        {
            key: "map_stores_location",
            label: "Contact & Hours Map",
            icon: "",
            group: "widgets",
            container: false,
            data: {
                name: "Contact & Hours Map",
            }
        },

        {
            key: "custom_form",
            label: "Custom Form",
            icon: "",
            group: "widgets",
            container: true,
            data: {
                form_id: null,
                width: 30,
                padding_x: 10,
                padding_y: 10,
                show_heading: true,
                heading_align: "center",
                heading_preset: 0,
                show_description: true,
                description_align: "center",
                description_preset: 0,
                align: "0 auto",
                label_preset: 0,
                label_help_preset: 0,
                label_description_preset: 0,
                input_font: 0,
                button_label: "Submit",
                button_type: 0,
                button_block: true,
                background_colour: 0,
                gap: 0,
                layout: "vertical",
            }
        },


        {
            key: "gift_card_image",
            label: "Gift card image + add to cart",
            icon: "",
            group: "widgets",
            container: false,
            data: {
                name: "Gift card image + add to cart",
                code: "",
                width: 800,
                align: "0 auto",
                radius: 15,
                padding_x: 20,
                padding_y: 20,
                gap: 20,
                shadow: true,
                button_type: 0,
                preset: 0,
                background: 0,
                button_block: false,
            }
        },
        {
            key: "balance_checker",
            label: "Gift card Balance Checker",
            icon: "",
            group: "widgets",
            container: true,
            data: {
                name: "Gift card Balance Checker",
                title: "Check your Gift Card balance",
                description: "Type in your Gift Card number (found on the back of the card, right below the barcode) and hit go.",
                width: 800,
                align: "0 auto",
                padding_x: 20,
                padding_y: 20,
                button_type: 0,
                preset: 0,
                description_preset: 0,
                background_colour: 0,
                button_label: "Check"
            }
        },

        // Third Party Plugins
        {
            key: "mailchimp_embedded",
            label: "Mailchimp signup | Embedded",
            icon: "",
            group: "third_party_plugins",
            container: true,
            data: {
                name: "Mailchimp signup | Embedded",
                url: "",
                heading: "Subscribe",
                heading_preset: 0,
                subheading: "",
                subheading_preset: 0,
                label_preset: 0,
                response_preset: 0,
                button_type: 0,
                show_name: false,
                show_phone: false,
                background_colour: 0,
                width: 1248,
                has_width: false,
                align: "0 auto",
                vertical: false,
                padding_x: 10,
                padding_y: 10,
            }
        },

        {
            key: "constant_contact_embedded",
            label: "Constant Contact | Embedded",
            icon: "",
            group: "third_party_plugins",
            container: true,
            data: {
                name: "Constant Contact | Embedded",
                form_id : "",
                background_colour : 0,
                contained : false,
                width : 1248,
                height : 400,
                align : "0 auto",
                padding_x : 10,
                padding_y : 10,
            }
        },

        // Custom HTML/CSS/Javascript
        {
            key: "custom_html_css",
            label: "Custom HTML / CSS",
            icon: "",
            group: "custom_html_css",
            container: true,
            data: {
                name: "Custom HTML / CSS",
                html: "",
                css: ""
            }
        },

        {
            key: "custom_embed",
            label: "Custom Embed",
            icon: "",
            group: "custom_html_css",
            container: true,
            data: {
                name: "Custom Embed",
                embed_code: "",
            }
        },





    ]
}


export const scope = {



    fonts: [
        {
            id: 1,
            name: "Averta Regular.woff",
            path: "\/bm_site_content_fonts\/Averta Regular.woff",
        },
        {
            id: 2,
            name: "Webdings V2.woff",
            path: "\/bm_site_content_fonts\/Webdings V2.woff",
        }
    ],

    meta: {
        favicon: "",
        email_header: "",
        share_image: ""
    },

    backgrounds: {

        background_color: 2,
        background_image: "",
        alt: "test",
        fixed: false,
        tile: false,
        container_color: 1,
        container_transparent: false,
    },

    contents: [
        {
            id: 1,
            name: "Paragraph",
            active: true,
            color: 2,
            text_shadow: { color: 1, x: 0, y: 0, b: 0 },
            underline: { color: 1, underline: false },
            border: { color: 1, size: 0, left: true, top: true, right: true, bottom: true, radius: 0 },
            bg_shadow: { color: 1, x: 0, y: 0, b: 0 },
        }
    ],

    buttons: [
        {
            id: 1,
            active: true,
            name: "Standard Button",
            // init_font: 1,
            // init_style: 1,
            // init_size: 14,
            // init_ls: 10,
            // init_color: 1,
            // init_bg_color: 19,
            // init_padding: { x: 10, y: 10 },
            // init_border: { color: 2, size: 1, radius: 0 },
            // init_drop_shadow: { color: 2, x: 0, y: 0, b: 0 },

            // hover_style: 1,
            // hover_ls: 10,
            // hover_color: 1,
            // hover_bg_color: 1,
            // hover_border: { color: 2, size: 1, radius: 0 },
            // hover_drop_shadow: { color: 2, x: 0, y: 0, b: 0 }

        },
        { id: 2, active: false },
        { id: 3, active: false },
        { id: 4, active: false },
        { id: 5, active: false },
        { id: 6, active: false },
        { id: 7, active: false },
        { id: 8, active: false },
        { id: 9, active: false },
        { id: 10, active: false },
    ],

    links: {
        init_style: 1,
        init_color: 9,
        init_underline: false,
        hover_style: 1,
        hover_color: 9,
        hover_underline: false,
    },

    text_styles: [
        { id: 1, label: "Regular", weight: "normal", style: "normal" },
        { id: 2, label: "Italic", weight: "normal", style: "italic" },
        { id: 3, label: "Bold", weight: "bold", style: "normal" },
        { id: 4, label: "Bold Italic", weight: "bold", style: "italic" }
    ],


    site_text: {
        base_font: 1,
        base_font_size: 1,
    },



    font_sizes: [
        {
            id: 1,
            size: "14px",
            default: true,
        },
        {
            id: 2,
            size: "16px",
            default: false,
        },
        {
            id: 3,
            size: "18px",
            default: false,
        }
    ],

    templates: [
        {
            id: 1,
            name: "Default",
            date_updated: 1676052020,
            selected: true,
        },

        {
            id: 2,
            name: "New",
            date_updated: 1676052020,
            selected: false,
        }
    ],


    colours: [
        {
            "active": true,
            "name": "Background",
            "id": 1,
            "default": true,
            "color": {
                "red": 253,
                "green": 253,
                "blue": 253,
                "alpha": 1,
                "hue": 0,
                "saturation": 0,
                "value": 99,
                "style": "rgba(253, 253, 253, 1)"
            },
            "gradient": false,
            "type": "solid"
        },
        {
            "active": true,
            "name": "Paragraph",
            "id": 2,
            "default": true,
            "color": {
                "red": 80,
                "green": 80,
                "blue": 80,
                "alpha": 1,
                "hue": 0,
                "saturation": 0,
                "value": 31,
                "style": "rgba(80, 80, 80, 1)"
            },
            "gradient": false,
            "type": "solid"
        },
        {
            "active": true,
            "name": "Menu BG",
            "id": 3,
            "default": true,
            "color": {
                "red": 240,
                "green": 177,
                "blue": 36,
                "alpha": 1,
                "hue": 41,
                "saturation": 85,
                "value": 94,
                "style": "rgba(240, 177, 36, 1)"
            },
            "gradient": false,
            "type": "solid"
        },
        {
            "active": true,
            "name": "Menu Text",
            "id": 4,
            "default": true,
            "color": {
                "red": 255,
                "green": 255,
                "blue": 255,
                "alpha": 1,
                "hue": 0,
                "saturation": 0,
                "value": 100,
                "style": "rgba(255, 255, 255, 1)"
            },
            "gradient": false,
            "type": "solid"
        },
        {
            "active": true,
            "name": "Open Menu BG",
            "id": 5,
            "default": true,
            "color": {
                "red": 42,
                "green": 41,
                "blue": 37,
                "alpha": 1,
                "hue": 48,
                "saturation": 12,
                "value": 16,
                "style": "rgba(42, 41, 37, 1)"
            },
            "gradient": false,
            "type": "solid"
        },
        {
            "active": true,
            "name": "Open Menu Text",
            "id": 6,
            "default": true,
            "color": {
                "red": 240,
                "green": 177,
                "blue": 36,
                "alpha": 1,
                "hue": 41,
                "saturation": 85,
                "value": 94,
                "style": "rgba(240, 177, 36, 1)"
            },
            "gradient": false,
            "type": "solid"
        },
        {
            "active": true,
            "name": "Header BG",
            "id": 7,
            "default": true,
            "color": {
                "red": 42,
                "green": 41,
                "blue": 37,
                "alpha": 1,
                "hue": 48,
                "saturation": 12,
                "value": 16,
                "style": "rgba(42, 41, 37, 1)"
            },
            "gradient": false,
            "type": "solid"
        },
        {
            "active": true,
            "name": "Header Text",
            "id": 8,
            "default": true,
            "color": {
                "red": 218,
                "green": 213,
                "blue": 203,
                "alpha": 1,
                "hue": 40,
                "saturation": 7,
                "value": 85,
                "style": "rgba(218, 213, 203, 1)"
            },
            "gradient": false,
            "type": "solid"
        },


        {
            "active": true, "name": "Links", "id": 9, "color": {
                "red": 0,
                "green": 102,
                "blue": 153,
                "alpha": 1,
                "hue": 200,
                "saturation": 100,
                "value": 60,
                "style": "rgba(0, 102, 153, 1)"
            },
            "gradient": false,
        },
        { "active": false, "name": "", "id": 10 },
        { "active": false, "name": "", "id": 11 },
        { "active": false, "name": "", "id": 12 },
        { "active": false, "name": "", "id": 13 },
        { "active": false, "name": "", "id": 14 },
        { "active": false, "name": "", "id": 15 },
        { "active": false, "name": "", "id": 16 },
        { "active": false, "name": "", "id": 17 },
        { "active": false, "name": "", "id": 18 },

        {
            "active": true, "name": "Button BG", "id": 19, "color": false,
            "gradient": {
                "points": [
                    {
                        "left": 100,
                        "red": 0,
                        "green": 0,
                        "blue": 0,
                        "alpha": 1
                    },
                    {
                        "left": 0,
                        "red": 102,
                        "green": 102,
                        "blue": 102,
                        "alpha": 1
                    }
                ],
                "type": "linear",
                "degree": 0,
                "style": "linear-gradient(0deg,rgba(102, 102, 102, 1) 0%,rgba(0, 0, 0, 1) 100%)"
            },
            "type": "gradient",
        },
        { "active": false, "name": "", "id": 20 },
        { "active": false, "name": "", "id": 21 },
        { "active": false, "name": "", "id": 22 },
        { "active": false, "name": "", "id": 23 },
        { "active": false, "name": "", "id": 24 },
        { "active": false, "name": "", "id": 25 },
        { "active": false, "name": "", "id": 26 },
        { "active": false, "name": "", "id": 27 },
        { "active": false, "name": "", "id": 28 },

    ]



}



export const theme = {
    "icons": {
        "logo": {
            "key": "logo",
            "label": "Logo",
            "path": "https:\/\/bookmanager.com\/i\/test000\/\/hi-mike.jpg"
        },
        "mobile_logo": {
            "key": "mobile_logo",
            "label": "Mobile Logo",
            "path": "\/logo_navbar"
        },
        "favicon": {
            "key": "favicon",
            "label": "Favicon",
            "path": "\/favicon"
        },
        "background": {
            "key": "background",
            "label": "Background",
            "path": "\/background"
        }
    },
    "fontlist": {
        "comic-sans": {
            "key": "comic-sans",
            "label": "Comic Sans",
            "family": "'Comic Sans'",
            "url": null
        },
        "default": {
            "key": "default",
            "label": "Default",
            "family": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
            "url": null
        }
    },
    "fonts": {
        "paragraph": {
            "key": "paragraph",
            "label": "Paragraph",
            "value": "comic-sans"
        },
        "headings": {
            "key": "headings",
            "label": "Headings",
            "value": "default"
        },
        "menu": {
            "key": "menu",
            "label": "Menu",
            "value": "default"
        }
    },
    "colors": {
        "primary": {
            "key": "primary",
            "label": "Primary",
            "color": "#f00f0f"
        },
        "accent": {
            "key": "accent",
            "label": "Accent",
            "color": "#1e90ff"
        },
        "background": {
            "key": "background",
            "label": "Background",
            "color": "#ffffff"
        },
        "paragraph": {
            "key": "paragraph",
            "label": "Paragraph",
            "color": "#505050"
        },
        "headings": {
            "key": "headings",
            "label": "Headings",
            "color": "#000000"
        },
        "menubg": {
            "key": "menubg",
            "label": "Menu BG",
            "color": "#505050"
        },
        "menu": {
            "key": "menu",
            "label": "Menu",
            "color": "#bfbfbf"
        },

        "search_bg": {
            "key": "search_bg",
            "label": "Search BG",
            "color": "#bfbfbf"
        }


    }
}


export const data = [
    {
        "id": 22,
        "url": "\/tobias",
        "name": "Tobias",
        "order": 0,
        "enabled": true,
        "parent_id": null,
        "hidden": true,
        "new_tab": false
    },
    {
        "id": 23,
        "url": "\/code",
        "name": "Code",
        "order": 0,
        "enabled": false,
        "parent_id": 22,
        "hidden": false,
        "new_tab": false
    },
    {
        "id": 21,
        "url": "\/board_games",
        "name": "Board Games",
        "order": 1,
        "enabled": false,
        "parent_id": 22,
        "hidden": false,
        "new_tab": false
    },
    {
        "id": 24,
        "url": "\/kristi",
        "name": "kristi",
        "order": 1,
        "enabled": false,
        "parent_id": null,
        "hidden": false,
        "new_tab": false
    },
    {
        "id": 25,
        "url": "\/testing",
        "name": "Testing",
        "order": 2,
        "enabled": true,
        "parent_id": null,
        "hidden": false,
        "new_tab": false
    },
    {
        "id": 26,
        "url": "\/about_us",
        "name": "About us",
        "order": 3,
        "enabled": true,
        "parent_id": null,
        "hidden": false,
        "new_tab": false
    },
    {
        "id": 27,
        "url": "\/shabbat___holid",
        "name": "Shabbat \/ Holidays",
        "order": 4,
        "enabled": true,
        "parent_id": null,
        "hidden": false,
        "new_tab": false
    },
    {
        "id": 28,
        "url": "\/chanukah",
        "name": "Chanukah",
        "order": 0,
        "enabled": true,
        "parent_id": 27,
        "hidden": false,
        "new_tab": false
    },
    {
        "id": 29,
        "url": "\/passover",
        "name": "Passover",
        "order": 1,
        "enabled": true,
        "parent_id": 27,
        "hidden": false,
        "new_tab": false
    },
    {
        "id": 30,
        "url": "\/products",
        "name": "Products",
        "order": 5,
        "enabled": true,
        "parent_id": null,
        "hidden": false,
        "new_tab": false
    },
    {
        "id": 31,
        "url": "\/books",
        "name": "Books",
        "order": 0,
        "enabled": true,
        "parent_id": 30,
        "hidden": false,
        "new_tab": false
    },
    {
        "id": 32,
        "url": "\/jewellry___gift",
        "name": "Jewellry & Giftware",
        "order": 1,
        "enabled": true,
        "parent_id": 30,
        "hidden": false,
        "new_tab": false
    },
    {
        "id": 33,
        "url": "https:\/\/duckduckgo.com",
        "name": "testg",
        "order": 6,
        "enabled": true,
        "parent_id": null,
        "hidden": false,
        "new_tab": true
    },
    {
        "id": 34,
        "url": "\/gift_certificat",
        "name": "Gift Certificates",
        "order": 7,
        "enabled": true,
        "parent_id": null,
        "hidden": false,
        "new_tab": false
    },
    {
        "id": 35,
        "url": "\/ram",
        "name": "ram",
        "order": 8,
        "enabled": true,
        "parent_id": null,
        "hidden": false,
        "new_tab": false
    },
    {
        "id": 36,
        "url": "https:\/\/downloadram.net",
        "name": "1",
        "order": 0,
        "enabled": true,
        "parent_id": 35,
        "hidden": false,
        "new_tab": false
    },
    {
        "id": 37,
        "url": "https:\/\/downloadram.net",
        "name": "2",
        "order": 1,
        "enabled": true,
        "parent_id": 35,
        "hidden": false,
        "new_tab": true
    },
    {
        "id": 38,
        "url": "\/3",
        "name": "3",
        "order": 2,
        "enabled": true,
        "parent_id": 35,
        "hidden": false,
        "new_tab": false
    },
    {
        "id": 40,
        "url": "\/browse\/filter\/s\/fic\/fic064\/a\/ageadult\/g\/en\/v\/popularity",
        "name": "Kurtis' Custom Menu",
        "order": 9,
        "enabled": true,
        "parent_id": null,
        "hidden": false,
        "new_tab": true
    }
]